var React = require('react');

function EditInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6 14L18 2l3.961 4.026L10 18zm3.25 4.25L3 21l2.75-6.25","fill":"none","strokeLinecap":"square","strokeLinejoin":"round","stroke":"currentColor","strokeWidth":"2"}));
}

EditInline.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = EditInline;

EditInline.default = EditInline;
